import script from "./CRMDateNavigator.vue?vue&type=script&setup=true&lang=js"
export * from "./CRMDateNavigator.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__